export const open_sim_after_device_add_dialog = (sim_in_device_type, msisdn, sim_id) => ({
    type: 'SIM_AFTER_DEVICE_ADD__OPEN',
    sim_in_device_type,
    msisdn,
    sim_id,
});
export const close_sim_after_device_add_dialog = () => ({
    type: 'SIM_AFTER_DEVICE_ADD__CLOSE',
});
